// extracted by mini-css-extract-plugin
export var legendIndicator = "_cv-1";
export var legendRight = "_cv-0";